import { render } from "./PositiveAlert.vue?vue&type=template&id=2a46762e"
import script from "./PositiveAlert.vue?vue&type=script&lang=js"
export * from "./PositiveAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__